import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {ArenaConfiguration} from '../../../../services/configurations/config-data-sections/arenas.configuration';
import classNames from "classnames";
import {LobbyWrapperBox} from "../../../../basic-components/lobby-wrapper/lobby-wrapper.box";
import {LobbyGridBox} from "../../../../basic-components/lobby-grid/lobby-grid.box";
import {observer} from 'mobx-react';
import {ArenaGamesListsComponent} from "../../../arena-games-lists/arena-games-lists.component";
import {FreeToPlayAnimatedIconComponent} from '../../../free-to-play-animated-icon/free-to-play-animated-icon.component';

export interface MiniOrbitCasinoArenaComponentProps {
    arenaName: string;
}

export const MiniOrbitCasinoArenaComponent = observer(
    class MiniOrbitCasinoArenaComponent extends OrbitComponent<MiniOrbitCasinoArenaComponentProps> {

        private get config(): ArenaConfiguration {
            return this.services.arenas.getArenaConfig(this.props.arenaName);
        }

        render() {

            return (
                <LobbyWrapperBox className={'cy-lobby-wrapper-miniorbit-arena'}>
                    <LobbyGridBox className={classNames('cy-lobby-grid-miniorbit-arena')}>
                        <div>
                            <ArenaGamesListsComponent key={this.props.arenaName} arenaName={this.props.arenaName} />
                        </div>
                    </LobbyGridBox>
                    <FreeToPlayAnimatedIconComponent />
                </LobbyWrapperBox>
            );
        }
    }
);